import { LearnLayout } from "./Layout/LearnLayout";

export const PeakAmbitionLearn = () => {
  return (
    <LearnLayout videoUrl="https://www.loom.com/embed/bbbc4e8b38b149d989386ac5fc138e87?sid=2228388a-db73-4644-9939-b8ea600ba4b7">
      <h3>Peak Ambition</h3>
      <p>
        <p>
          If a company doesn't know where it's going, it probably doesn't know
          what success looks like, either.
        </p>
        <p>
          Your peak ambition helps solve this blind spot by creating a dated
          financial milestone, framed as a future headline in a publication,
          that defines your company's journey.
        </p>

        <h4>What Is It</h4>
        <p>
          A realistic yet ambitious future headline that conceptualizes your
          company's financial achievement, paired with a specific future date
          and publication name.
        </p>

        <h4>How It Works</h4>
        <p>
          1. Project your company forward: Think 3+ years ahead into the future.
        </p>
        <p>
          2. Quantify success: What are your revenue targets, valuation, market
          position, etc?
        </p>
        <p>
          3. Picture the headline and publication: “[Your Company] Achieves
          [Ambition] by [Date], Stuns the Market.” Where would this achievement
          be announced?
        </p>

        <h4>The Result</h4>
        <p>
          Total alignment on the financial ambition for the company, and by when
          you hope to achieve it.
        </p>

        <h4>How Vojomo Helps</h4>
        <p>
          Tell Vo about your financial vision for the future. What are your
          targets, and what would your headline sound like? You can also check
          out our video to dive deeper into the philosophy behind creating a
          peak ambition.
        </p>
      </p>
    </LearnLayout>
  );
};
